import {mediaQuery} from "./mediaQuery";
import styled from "styled-components";

export default styled.div`
    display: block;
    ${mediaQuery.phone`display: none;`}
`;
